// removed by extract-text-webpack-plugin
module.exports = {"marketGroup":"_3DVbaDqJenKsq-gVkUsKLU","marketType":"_3_SoqVk3wU8ZkSV06LTvXb","winningMarginTeamHeader":"_9dpONT-P038tXWAOORKP2","scoreGroup":"JrcUh1tcm2LD6DmrUz2IX","marketText":"fou9eLIRa243NtzPvLARy","oddsButton":"fxw_q5B6ufKS7vKph64OR","scoreGroup2ndLevel":"IxebRxrGHPHcP8UswUGAW"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/tennis/css/markets.css
// module id = 227
// module chunks = 0